import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: ['Avenir', 'sans-serif']
  },
  palette: {
    primary: {
      main: 'rgb(0, 160, 223)',
      contrastText: '#fff'
    }
  },
  props: {
    MuiButton: {
      disableRipple: true,
      disableFocusRipple: true
    },
    MuiInputLabel: {
      shrink: true
    },
    MuiCheckbox: {
      disableRipple: true
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          "&.MuiButton-root": {
            display: "inline-block",
            backgroundColor: "transparent",
            color: "#007FAD",
            borderRadius: "4px",
            border: "2px solid #007FAD",
            padding: "0.5rem 1rem",
            textTransform: "none",
            fontFamily: "Avenir",
            fontSize: "1rem",
            fontWeight: "500",
            TransitionEvent: "box-shadow 0.2s ease-in-out, transform 0.2s ease-in-out",
            transformOrigin: "center center",
          },
        }
      }
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          "&.MuiToggleButtonGroup-root": {
            borderBottom: "0.5px solid #707070B3",
            borderRadius: "0px",
          },
          "&.MuiToggleButtonGroup-grouped": {

          },
        }
      }
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          "&.MuiToggleButton-root": {
            backgroundColor: "transparent",
            color: "#000",
            textTransform: "none",
            fontFamily: "Avenir",
            fontWeight: "400",
            padding: "16px 0px",
            border: "none",
            borderRadius: "0px",
            fontSize: "16px",
          },
          "&.MuiToggleButton-root:not(:last-child)": {
            marginRight: "32px",
          },
          "&.Mui-selected": {
            color: "#007FAD",
            borderBottom: "2px solid #007FAD",
            borderRadius: "0px",
            zIndex: "1",
          },
          "&.MuiToggleButton-root:hover": {
            backgroundColor: "transparent",
            color: "#007FAD",
            borderBottom: "2px solid #007FAD",
          },
        }
      }
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          '&.MuiDataGrid-root ': {
            border: "none",
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: "#E9F5FA",
            fontWeight: "600",
            color: "#2F2F2F",
            marginBottom: "1rem",
            border: "none",
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: "bold",
            color: "#2F2F2F",
            paddingLeft: "16px",
          },
          '& .MuiDataGrid-row': {
            marginTop: "1rem",
            maxHeight: "10rem !important",
            height: "auto !important",
            borderRadius: "4px",
            borderLeft: "4px solid #009CD6",
          },
          '& .MuiDataGrid-row:hover': {
            cursor: "pointer",
            boxShadow: "0 10px 24px rgb(31 167 217 / 21%)",
            transform: "translateY(-0.125rem)",
          },
          '& .MuiDataGrid-cell': {
            maxHeight: "10rem !important",
            height: "auto !important",
            color: "#6E6E6E",
            backgroundColor: "#fff",
            fontsize: "14px",
            border: "none",
            padding: "1.5rem 0 1.5rem 1.5rem !important",
          },
          '& .MuiDataGrid-row > .MuiDataGrid-cell:first-of-type': {
            fontWeight: "bold",
          },
          // '& .MuiDataGrid-row > .MuiDataGrid-cell:last-child': {
          // },
          '& .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell': {
            whiteSpace: "break-spaces",
          },
          '& .MuiDataGrid-columnSeparator': {
            display: "none",
          },
        },
      },
    },
    MuiDatePicker: {
      styleOverrides: {
        day: {
          "&.Mui-selected": {
            backgroundColor: "black",
            color: "white",
          }
        }

      }
    },
    MuiIconButton: {
      styleOverrides: {
        sizeMedium: {
          color: 'white'
        }
      }
    },
  },
  overrides: {
    MuiContainer: {
      root: {
        maxWidth: '900px'
      },
      maxWidthSm: {
        maxWidth: '900px'
      }
    },
    MuiButton: {
      root: {
        borderRadius: '2px',
        boxShadow: 'none',
        marginTop: '2rem',
        textTransform: 'none',
      }
    },
    MuiFormControl: {
      root: {
        width: '100%'
      }
    },
    MuiFilledInput: {
      root: {
        '&$disabled': {
          backgroundColor: 'transparent',
          border: '0',
          color: 'inherit',
          '&:before': { display: 'none' }
        }
      }
    },
    MuiInputLabel: {
      root: {
        color: 'black',
        '&$disabled': {
          color: 'black'
        }
      },
      shrink: {
        transformOrigin: 'top left',
        transform: 'translate(12px, 10px) scale(0.75)',
        fontSize: '100%',
        color: 'black',
        '&$disabled': {
          color: 'black'
        }
      }
    },
    MuiSvgIcon: {
      root: {
        '&.Mui-disabled': { display: 'none' }
      }
    }
  }
});

export default theme;
